function setDesktopSubmenuState( item, isOpen ) {
	const submenu = item.querySelector( ':scope > .js-header-submenu' );
	const link = item.querySelector( ':scope > .js-header-link' );

	if ( ! submenu ) {
		return;
	}

	item.classList.toggle( 'is-open', isOpen );
	submenu.classList.toggle( 'is-open', isOpen );
	submenu.setAttribute( 'aria-hidden', isOpen ? 'false' : 'true' );

	if ( link ) {
		link.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	}
}

function initDesktopSubmenus( root ) {
	root.querySelectorAll( '.js-header-desktop-item.has-submenu' ).forEach( ( item ) => {
		let closeTimeout = null;

		const openSubmenu = () => {
			if ( closeTimeout ) {
				window.clearTimeout( closeTimeout );
				closeTimeout = null;
			}

			setDesktopSubmenuState( item, true );
		};

		const closeSubmenu = () => {
			closeTimeout = window.setTimeout( () => {
				setDesktopSubmenuState( item, false );
			}, 120 );
		};

		item.addEventListener( 'mouseenter', openSubmenu );
		item.addEventListener( 'mouseleave', closeSubmenu );
		item.addEventListener( 'focusin', openSubmenu );
		item.addEventListener( 'focusout', ( event ) => {
			if ( item.contains( event.relatedTarget ) ) {
				return;
			}

			closeSubmenu();
		} );
	} );
}

function setMobileNavState( root, isOpen ) {
	const toggle = root.querySelector( '.js-header-mobile-toggle' );
	const nav = root.querySelector( '.js-header-mobile-nav' );
	const openIcon = root.querySelector( '.js-header-mobile-open-icon' );
	const closeIcon = root.querySelector( '.js-header-mobile-close-icon' );

	if ( ! toggle || ! nav ) {
		return;
	}

	toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	nav.setAttribute( 'aria-hidden', isOpen ? 'false' : 'true' );
	nav.classList.toggle( 'is-open', isOpen );

	if ( openIcon && closeIcon ) {
		openIcon.classList.toggle( 'hidden', isOpen );
		closeIcon.classList.toggle( 'hidden', ! isOpen );
	}
}

function setMobileSubmenuState( item, isOpen ) {
	const link = item.querySelector( ':scope > .js-header-mobile-link' );
	const submenu = item.querySelector( ':scope > .js-header-mobile-submenu' );

	if ( ! link || ! submenu ) {
		return;
	}

	item.classList.toggle( 'is-open', isOpen );
	link.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	submenu.setAttribute( 'aria-hidden', isOpen ? 'false' : 'true' );
	submenu.classList.toggle( 'is-open', isOpen );
}

function initMobileNav( root ) {
	const toggle = root.querySelector( '.js-header-mobile-toggle' );

	if ( toggle ) {
		toggle.addEventListener( 'click', () => {
			const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';
			setMobileNavState( root, ! isOpen );
		} );
	}

	root.querySelectorAll( '.js-header-mobile-item' ).forEach( ( item ) => {
		const link = item.querySelector( ':scope > .js-header-mobile-link[data-mobile-submenu-target]' );
		if ( ! link ) {
			return;
		}

		link.addEventListener( 'click', ( event ) => {
			const isOpen = item.classList.contains( 'is-open' );

			if ( ! isOpen ) {
				event.preventDefault();
			}

			setMobileSubmenuState( item, ! isOpen );
		} );
	} );
}

function initHeaderInteractions() {
	document.querySelectorAll( '.lasting-order-header-block' ).forEach( ( root ) => {
		initDesktopSubmenus( root );
		initMobileNav( root );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initHeaderInteractions );
} else {
	initHeaderInteractions();
}
